import FilterForm from 'components/forms/FilterForm';
import { Form, FormProps, Input, Radio, Select, Space } from 'antd';
import { IAssessment } from 'interfaces/assessments';
import { QUESTION_KIND_OPTIONS } from 'services/questions';
import { useSelect } from '@refinedev/antd';

export interface IQuestionFilter {
  statement: string;
  assessment_id: string;
  status: string;
  by_kind: IAssessment['kind'];
}

interface QuestionFilterProps {
  searchFormProps: FormProps<IQuestionFilter>;
}

export const QuestionsFilter = ({ searchFormProps }: QuestionFilterProps) => {
  const { selectProps: assessmentSelectProps } = useSelect<IAssessment>({
    resource: 'assessments',
    optionLabel: 'name',
    optionValue: 'id',

    onSearch: value => [
      {
        field: 'filter[full_name]',
        operator: 'eq',
        value
      }
    ],

    pagination: {
      mode: 'server'
    }
  });

  return (
    <FilterForm searchFormProps={searchFormProps}>
      <Form.Item name="statement" className="mb-0 w-80">
        <Input placeholder="Digite o enunciado da questão" />
      </Form.Item>

      <Form.Item name="assessment_id" className="mb-0 w-80">
        <Select placeholder="Curso | Avaliação" {...assessmentSelectProps} />
      </Form.Item>

      <Space className="mb-0 bg-slate-100 rounded-md p-2 ">
        <Space align="center" size="small">
          <span className="text-gray-700">Status:</span>
          <Form.Item name="status" className="mb-0" initialValue={null}>
            <Radio.Group>
              <Radio.Button value={null}>Todas</Radio.Button>
              <Radio.Button value="active">Ativas</Radio.Button>
              <Radio.Button value="inactive">Inativas</Radio.Button>
              <Radio.Button value="nullified">Anuladas</Radio.Button>
            </Radio.Group>
          </Form.Item>
        </Space>
      </Space>

      <Space className="mb-0 bg-slate-100 rounded-md p-2 ">
        <Space align="center" size="small">
          <span className="text-gray-700">Tipo:</span>
          <Form.Item name="by_kind" className="mb-0" initialValue="">
            <Radio.Group>
              <Radio.Button value="">Todos</Radio.Button>
              {QUESTION_KIND_OPTIONS.map(option => (
                <Radio.Button key={option.value} value={option.value}>
                  {option.label}
                </Radio.Button>
              ))}
            </Radio.Group>
          </Form.Item>
        </Space>
      </Space>
    </FilterForm>
  );
};
